import { MY_GROUPS_FEED_TYPE } from 'hb-react/frontoffice/apps/LiveFeed/constants/FeedType';
import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import { useLiveFeedContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LiveFeedContext';
import { getItemsDedicatedUrl } from 'hb-react/frontoffice/apps/LiveFeed/utils/getItemsDedicatedUrl';
import AttachedEmbed from 'hb-react/frontoffice/components/AttachedEmbed';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import AttachedFiles from 'hb-react/shared/components/DesignSystem/AttachedFiles';

import AssociatedRecordContent from './AssociatedRecordContent';
import AttachedImages from '../AttachedImages';
import AttachedVideos from '../AttachedVideos';
import Landing from '../Landing';

const UserPost = () => {
  const {
    attachedFiles,
    attachedImages,
    attachedVideos,
    categories,
    comments,
    content,
    embed,
    id,
    isRowVisibleOrOutOfView,
    likes,
    onTogglePostLike,
    onUpdateItem,
    originalType,
    owner,
    publishedAt,
    topic,
    totalComments,
    type,
    fromRecord,
  } = useLandingContext();

  const {
    config: { type: configType, topic: topicFromGroupFeed },
  } = useLiveFeedContext();

  const { currentUser, currentUrl } = useDefaultAppContexts();

  const sharePostUrl = getItemsDedicatedUrl({
    item: {
      id,
      topic_id: topic ? topic.id : topicFromGroupFeed?.id,
      type: originalType,
    },
    liveFeedType: configType,
    currentUrl,
  });

  return (
    <Landing displayTopicName={configType === MY_GROUPS_FEED_TYPE}>
      <AssociatedRecordContent fromRecord={fromRecord} />
      {attachedImages?.length ? (
        <AttachedImages
          canDisplay={isRowVisibleOrOutOfView}
          categories={categories}
          comments={comments || []}
          content={content}
          createdAt={publishedAt}
          id={id}
          images={attachedImages}
          likes={likes}
          onTogglePostLike={onTogglePostLike}
          onUpdateItem={onUpdateItem}
          originalType={originalType}
          owner={owner}
          sharePostUrl={sharePostUrl}
          totalComments={totalComments}
          type={type}
          user={currentUser}
        />
      ) : null}
      {attachedVideos?.length ? (
        <AttachedVideos attachedVideos={attachedVideos} />
      ) : null}
      <AttachedEmbed embed={embed} />
      {attachedFiles?.length > 0 && (
        <AttachedFiles
          attachedFiles={attachedFiles}
          display="inline-block"
          maxWidth="100%"
        />
      )}
    </Landing>
  );
};

export default UserPost;
